import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import type { FeedbackDTO, FeedbackResponseDTO } from './models/FeedbackModel';
/**
 * Feedback API top create Request for the Api to create a feedback, edit a feedback, delete a feedback
 * with routes to upload files and images
 */

@Injectable({
  providedIn: 'root',
})
export class FeedbackApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly BASE = '/api/feedback/v2';
  /**
   * makes a post call to the feedback endpoint and return an observable with a feedback entity containing the feedback id
   * @returns
   */
  createFeedback(payload: FeedbackDTO) {
    return this.httpClient.post<FeedbackResponseDTO>(`${this.BASE}/feedbacks`, payload);
  }
  /**
   *
   * @param param0
   * @returns
   */
  updateFeedback(payload: FeedbackDTO) {
    return this.httpClient.put(`${this.BASE}/feedbacks`, payload);
  }
  /**
   *
   * @param id
   * @returns
   */
  deleteFeedback(id: string) {
    return this.httpClient.delete(`${this.BASE}/feedbacks/${id}`);
  }
  /**
   *
   * @param param0
   * @returns
   */
  uploadScreenshot({ id, file }: { id: string; file: File }) {
    const formData = new FormData();
    formData.append('files', file, 'screenshot.png');
    return this.httpClient.post(`${this.BASE}/feedbacks/${id}/upload/screenshots`, formData);
  }
  /**
   *
   * @param param0
   * @returns
   */
  uploadFile({ id, file }: { id: string; file: File }) {
    const formData = new FormData();
    formData.append('file', file);
    return this.httpClient.patch(`${this.BASE}/feedbacks/${id}/upload/files`, formData);
  }
}
